'use strict';

function LoanLiquidAdditionalPaymentDate() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];
  this._maxDate = null;
  this._minDate = null;
  this._dateFormat = 'YYYY-MM-DD';

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (!this._checkAdditionalPaymentFlowEligibility()) {
      return;
    }

    this._paymentDateOptions = $('#payment-date-options');
    this._customDateRadio = $('#custom-date-radio');
    this._paymentDate = $('#payment-date');
    this._calendarDisabledSection = $(this.node).find('.loans-payment-additional-date__calendar-disabled');
    this._form = $(this.node).find('form');
    this._trayCloseCta = $('.tray-modal-close');

    this._next_available_date = moment(this._liquidLoan.additional_payment_maximum_date);
    this._maxDate = this._liquidLoan.additional_payment_maximum_date ? this._liquidLoan.additional_payment_maximum_date : moment().format(this._dateFormat);
    this._minDate = this._liquidLoan.additional_payment_minimum_date ? this._liquidLoan.additional_payment_minimum_date : moment().format(this._dateFormat);
    this._paymentDate.mogo().updateToday(this._maxDate);

    // Connections
    this._paymentDateOptions.on('change', this._onChangeDateOptions.bind(this));
    this._paymentDate.on('change', function () {
      _this._paymentDate.mogo().hideError();
    });
    this._form.on('submit', function (e) {
      e.preventDefault();
      if (_this._paymentDate.mogo().getState() == 'unselected') {
        _this._paymentDate.mogo().showErrorLabel(true, 'Select a date for your additional payment.');
        _this.analytics.pushEvent('form-errors', { FormErrors: ['date'] });
      } else if (_this._paymentDate.mogo().getState() == 'invalid' && _this._paymentDate.mogo().val() != _this.presenter._getComputedValue('next_available_payment_date')) {
        _this._paymentDate.mogo().showErrorLabel(true, 'Invalid date!');
        _this.analytics.pushEvent('form-errors', { FormErrors: ['date'] });
      } else {
        var formAnalyticsID = _this._form.data('analytics-id');
        _this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
        _this._history.goToUrl('/member/dashboard/loans/liquid/add-payment/additional-payment-amount');
      }
    });
    this._trayCloseCta.on('click', function () {
      _this.analytics.forcePushEvent('form-abandoned', { FormAbandoned: ['date'] });
    });

    // Extend view map, computed variables
    var dateCalFormat = this._paymentDate.mogo().calculationFormat;
    this.presenter.extendViewMap({
      'money.loans.loans[0].create_additional.date': {
        set: function set(val) {
          // To make the date calculation consistent with InputCanlendar when user types in random inputs.
          return moment(val, dateCalFormat).startOf('day').valueOf();
        },

        get: function (val) {
          // Need to return a full date with year.
          return val ? moment(val).format(this._dateFormat) : '';
        }.bind(this)
      },
      'money.loans.loans[0].create_additional.selection': {
        set: function set(val) {
          return val[0];
        }
      },
      'money.loans.loans[0].create_additional.amount': {
        set: function set(val) {
          return (+val).toFixed(2);
        }
      }
    });

    this.presenter.addComputedVariable('next_available_payment_date', ['money.loans.loans[0].additional_payment_maximum_date'], function (val) {
      return moment(val).format('ddd, MMM D');
    }.bind(this, this._next_available_date));

    // Calendar Validation, properties
    var dateTitle = {};
    dateTitle[this._maxDate] = 'Next available regular payment date';
    this._paymentDate.mogo().setDateTitles([dateTitle]);
    this._paymentDate.mogo().setDateValidation(this._setDateValidation.bind(this));
    this._paymentDate.mogo().setMonthValidation(this._setMonthValidation.bind(this));
    this._paymentDate.mogo().setYearValidation(this._setYearValidation.bind(this));

    // Default values
    if (!this._liquidLoan.create_additional || !this._liquidLoan.create_additional.selection) {
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.selection', 'next_available');
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.date', this._next_available_date.valueOf());
    }
    if (this._liquidLoan.additional_payment_minimum_date === this._liquidLoan.additional_payment_maximum_date) {
      this._disableCustomDateSelection();
      this.analytics.pushEvent('virtual-page-view', {
        Page: [window.location.href + '/regular_date_only']
      });
    } else {
      this.analytics.pushEvent('virtual-page-view');
    }

    // Hide loading
    $('.loans__tray-loader').addClass('hide');
    $('.loans__content-wrapper').removeClass('hide');
  };

  this._disableCustomDateSelection = function () {
    this._customDateRadio.mogo().setDisabled(true);
    this._calendarDisabledSection.show();
  };

  this._onChangeDateOptions = function (evt) {
    var target = null;
    if (evt) target = $(evt.target);else target = $('#payment-date-options');

    if (target.mogo().val() === 'custom') {
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.selection', 'custom');
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.date', null);
      this._paymentDate.mogo().updateCurrentDate(this._minDate);
    } else {
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.selection', 'next_available');
      this.presenter.setModelProperty('money.loans.loans[0].create_additional.date', this._next_available_date.valueOf());
    }
  };

  this._setDateValidation = function (year, month, date) {
    var mDate = moment(year + '-' + (month + 1) + '-' + date, this._dateFormat);

    // Can't be weekend
    if (mDate.day() === 0 || mDate.day() === 6) {
      return false;
    }

    // Date must be within the range between maxDate and minDate
    if (moment(mDate).isBefore(this._minDate, this._dateFormat) || moment(mDate).isSameOrAfter(this._maxDate, this._dateFormat)) {
      return false;
    }
    return true;
  };

  this._setMonthValidation = function (year, month) {
    if (moment(this._maxDate).month() == month || moment(this._minDate).month() == month) {
      return true;
    }
    return false;
  };

  this._setYearValidation = function (year) {
    if (moment(this._maxDate).year() == year || moment(this._minDate).year() == year) {
      return true;
    }
    return false;
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('next_available_payment_date');

    this._super();
  };
}